import React from 'react';

import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { InvitationRowStatus } from '@app/models/users';

const STATUS_COLOR: Record<InvitationRowStatus, string> = {
  [InvitationRowStatus.Sent]: 'processing',
  [InvitationRowStatus.Expired]: 'warning',
  [InvitationRowStatus.Accepted]: 'success',
  [InvitationRowStatus.Revoked]: 'default',
};

interface IProps {
  status: InvitationRowStatus;
}

export const InvitationStatusTag: React.FC<IProps> = ({ status }) => {
  const spaceT = useTranslation(NSKeys.spaceSettings);

  return <Tag color={STATUS_COLOR[status]}>{spaceT.t(`invitationStatus.${status}` as const)}</Tag>;
};
